module.exports = __webpack_public_path__ + "media/7.63234b93.mp3";